import styled from 'styled-components';

export default styled.div`
  && {
    .btn-business {
      padding: 14px 40px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn-mg {
        margin-right: 10px;
      }
      .btn-end-of-lease {
        background-color: black;
        color: white;
        text-align: center;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        width: 115px;
        height: 35px;
      }
      .btn-renew-lease {
        background-color: #ff8a00;
        color: white;
        width: 177px;
        height: 35px;
        border: none;
        border-radius: 5px;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      }
      .btn-update-lease {
        background-color: #ff8a00;
        color: white;
        width: 177px;
        height: 35px;
        border: none;
        border-radius: 5px;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      }
    }
    .info-lease {
      padding: 40px 65px;
      .lease {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
      }
      .statistics {
        padding: 39px 25px;
        .alert-lease {
          border-radius: 10px;
          background: red;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .anticon-exclamation-circle > svg {
            width: 14px;
            height: 14px;
            border-radius: 50px;
            margin-left: -5px;
            color: red;
            background-color: white;
          }
          .alert-text {
            margin-right: 15px;
            color: white;
          }
        }
      }
      .statistics-editable {
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        margin-top: 40px;
        .lease-equipment {
          padding: 10px 25px;
        }
      }
      .bd {
        border-bottom: 1px solid #dddddd;
      }
      .pb-16 {
        padding-bottom: 16px;
      }
      .pb-10 {
        padding-bottom: 10px;
      }
      .p-21 {
        padding-top: 21px;
        padding-bottom: 21px;
      }
      .pt-16 {
        padding-top: 16px;
      }
      .ml-5 {
        padding-left: 5px;
      }
    }
  }
`;
